exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*$vs-colors: (\n        lightest: rgba(60, 60, 60, 0.26),\n        light: rgba(60, 60, 60, 0.5),\n        dark: #333,\n        darkest: rgba(0, 0, 0, .15),\n) !default;*/\n.label-block {\n  max-width: 276px;\n}\n.label-block p {\n  font-size: 85.7142857143%;\n  line-height: 1.7;\n  margin-bottom: 0.7rem;\n  color: #393d41;\n}\n@media screen and (min-width: 1024px) {\n.label-block p {\n    letter-spacing: 0.53px;\n    line-height: 24px;\n}\n}", ""]);

// exports
